import store from "../../../state/store";
import { SET_CNV_CODING_GENES } from "../../../state/actions/actionTypes";

export const setCNVsCodingGenes = (params) => {
  store.dispatch({
    type: SET_CNV_CODING_GENES,
    params,
  });
};
